import { NotifyHelper } from "../../../helpers/toast";
import { objFormItemDefine } from "../../action-types/form/IFormItemActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const formItemActions = {
    ...generateActions(objFormItemDefine, "FORM_ITEM"),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SELECT_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SELECT_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SAVES_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormItemDefine, "FORM_ITEM",
        "SAVES_ERROR", (m: any) => NotifyHelper.Error(m))
}
